<!--
 * @Author: xiaopeiting
 * @Date: 2020-06-01 15:24:43
 * @LastEditTime: 2020-06-12 14:21:07
--> 
<template>
  <div
    v-if="isShowModal"
    class="expired-modal dis-flex flex-middle flex-center"
    @click.self="toggleModal(false)"
  >
    <div class="modal-wrap vertical flex-middle">
      <img class="img" src="https://res.pandateacher.com/O6SQ5ED61592824577078.png" />
      <div class="title">{{expireTitle}}</div>
      <div class="desc">有疑问请联系助教老师哦～</div>

      <div class="btn-know" @click="handleClickKnow">
        <div class="text">我知道了</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { expireStorageKey } from '../type';
@Component({})
export default class CouponModal extends Vue {
  @Prop({ require: true }) storageKey!: expireStorageKey;
  @Prop({ require: true }) expireTitle!: string;
  isShowModal = false;

  toggleModal(status: boolean) {
    this.isShowModal = status;
  }

  handleClickKnow() {
    this.toggleModal(false);
    localStorage.setItem(this.storageKey, 'true');
  }
}
</script>

<style lang="scss" scoped>
@import '../../../style/flex.css';

.expired-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  box-sizing: content-box;
  width: 100vw;
  height: 100vh;
  padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top);
  background-color: rgba(1, 1, 1, 0.8);

  .modal-wrap {
    width: 580px;
    height: 552px;
    color: rgba(59, 53, 97, 1);
    background: linear-gradient(
      180deg,
      rgba(238, 227, 255, 1) 0%,
      rgba(248, 243, 255, 1) 54%,
      rgba(255, 255, 255, 1) 100%
    );
    border-radius: 36px;

    .img {
      width: 298px;
      height: 298px;
    }
    .title {
      font-weight: 600;
      font-size: 36px;
      letter-spacing: 3px;
    }
    .desc {
      margin-top: 10px;
      font-size: 28px;
      letter-spacing: 2px;
    }
    .btn-know {
      display: inline-block;
      width: 400px;

      height: 84px;
      margin-top: 50px;
      padding: 3px;
      line-height: 84px;
      background: -webkit-linear-gradient(right, #fff 0%, #fff 100%),
        -webkit-linear-gradient(135deg, rgba(224, 70, 255, 1), rgba(132, 110, 255, 1));
      background-clip: content-box, padding-box;
      border-radius: 42px;

      .text {
        color: rgba(216, 216, 216, 1);
        font-weight: 600;
        font-size: 36px;
        line-height: 78px;
        letter-spacing: 3px;
        text-align: center;
        background: linear-gradient(
          270deg,
          rgba(212, 76, 255, 1) 0%,
          rgba(154, 48, 255, 1) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
}
</style>